<template>
  <v-app>
    <v-app-bar
      :clipped-left="mobile"
      app
      color="primary"
      dark
      class="bg_toolbar"
      height="70px"
    >
      <v-card
        v-if="!mobile"
        class="bg_appbar_logo"
        flat
        color="white"
        style="border-radius: 0px 50px 50px 0px"
      >
        <v-row justify="center" align="center">
          <v-col align="center" cols="12" class="pb-0 pt-2 pl-1">
            <v-img
              :src="require('@/assets/royin-logo2.png')"
              max-width="40"
            ></v-img>
          </v-col>
        </v-row>
      </v-card>

      <v-app-bar-nav-icon
        v-if="mobile && show_menu"
        @click="navbar_drawer = !navbar_drawer"
      ></v-app-bar-nav-icon>
      <div v-if="mobile" class="ml-2">
        <v-img
          :src="require('@/assets/royin-logo2.png')"
          max-width="30"
        ></v-img>
      </div>
      <v-toolbar-title v-if="!mobile" style="margin-left: 120px">
        <h2>
          {{
            switch_language == "th"
              ? text.title_app_bar.th
              : switch_language == "en"
              ? text.title_app_bar.en
              : "-"
          }}
        </h2>
      </v-toolbar-title>
      <v-toolbar-title v-if="mobile" style="margin-left: 15px">
        <span style="font-size: 15px">
          {{
            switch_language == "th"
              ? text.title_app_bar.th
              : switch_language == "en"
              ? text.title_app_bar.en
              : "-"
          }}
        </span>
      </v-toolbar-title>
      <v-spacer></v-spacer>

      <v-spacer></v-spacer>

      <NotificationMenu v-if="show_menu && permission_request_word" />
      <!-- <v-divider v-if="show_menu" class="mx-2" inset vertical></v-divider> -->
      <div class="text-center" v-if="show_menu && !mobile">
        <v-menu offset-y :close-on-content-click="false">
          <template v-slot:activator="{ on }">
            <v-btn v-if="!desktop" icon v-on="on">
              <v-icon size="22">mdi-dots-vertical</v-icon>
            </v-btn>
            <v-btn v-else text v-on="on">
              <span class="text_body_5 mt-1">{{ fullName }}</span>
              <v-icon right size="22">keyboard_arrow_down</v-icon>
            </v-btn>
          </template>
          <!-- have not sub -->
          <v-list class="my-0 py-0" v-for="(item, i) in menus" :key="i">
            <v-list-item
              v-if="item.sub_menus.length == 0 && item.permission"
              :to="item.path == 'logout' ? '' : item.path"
              @click="item.path == 'logout' ? logout() : ''"
            >
              <v-list-item-icon>
                <v-avatar size="20" tile>
                  <img :src="item.img" />
                </v-avatar>
              </v-list-item-icon>
              <v-list-item-title>{{ item.title }}</v-list-item-title>
            </v-list-item>
            <!-- have sub -->
            <v-list-group
              class="my-0 py-0"
              no-action
              v-else-if="item.permission"
            >
              <template v-slot:activator>
                <v-list-item-icon>
                  <v-avatar size="20" tile>
                    <img :src="item.img" />
                  </v-avatar>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title v-text="item.title"></v-list-item-title>
                </v-list-item-content>
              </template>
              <v-list-item
                class="pl-10"
                v-for="subItem in item.sub_menus"
                :key="subItem.title"
                :to="subItem.path"
                v-if="subItem.permission"
              >
                <v-list-item-icon>
                  <v-avatar size="20" tile>
                    <img :src="subItem.img" />
                  </v-avatar>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title v-text="subItem.title"></v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </v-list-group>
          </v-list>
        </v-menu>
      </div>
    </v-app-bar>
    <v-navigation-drawer
      v-if="mobile && show_menu"
      v-model="navbar_drawer"
      :clipped="true"
      :floating="true"
      :mini-variant="false"
      :permanent="false"
      :temporary="true"
      app
      overflow
    >
      <v-list>
        <v-list-item>
          <v-list-item-icon class="mr-2">
            <v-avatar size="26">
              <img :src="require('@/assets/navbarImage/Profile.png')" />
            </v-avatar>
          </v-list-item-icon>
          <v-list-item-content class>
            <v-list-item-title class="title">{{ fullName }}</v-list-item-title>
            <v-list-item-subtitle>{{ roleName }}</v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>
        <v-divider></v-divider>
        <!-- have not sub -->
        <v-list class="my-0 py-0" v-for="(item, i) in menus" :key="i">
          <v-list-item
            v-if="item.sub_menus.length == 0 && item.permission"
            :to="item.path == 'logout' ? '' : item.path"
            @click="item.path == 'logout' ? logout() : ''"
          >
            <v-list-item-icon>
              <v-avatar size="20" tile>
                <img :src="item.img" />
              </v-avatar>
            </v-list-item-icon>
            <v-list-item-title>{{ item.title }}</v-list-item-title>
          </v-list-item>
          <!-- have sub -->
          <v-list-group class="my-0 py-0" no-action v-else-if="item.permission">
            <template v-slot:activator>
              <v-list-item-icon>
                <v-avatar size="20" tile>
                  <img :src="item.img" />
                </v-avatar>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title v-text="item.title"></v-list-item-title>
              </v-list-item-content>
            </template>
            <v-list-item
              class="pl-10"
              v-for="subItem in item.sub_menus"
              :key="subItem.title"
              :to="subItem.path"
              v-if="subItem.permission"
            >
              <v-list-item-icon>
                <v-avatar size="20" tile>
                  <img :src="subItem.img" />
                </v-avatar>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title v-text="subItem.title"></v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list-group>
        </v-list>
      </v-list>
    </v-navigation-drawer>

    <v-app-bar
      class="elevation-0"
      style="margin-top: 70px"
      color="#EEEEEE"
      height="50px"
      fixed
    >
      <v-spacer></v-spacer>
      <!-- languahe switch -->
      <v-toolbar-items v-show="current_path == '/search'">
        <v-btn text @click="setShowLanguage('en')">
          <v-img
            class="mr-2"
            width="20"
            :src="require('@/assets/flag/united-kingdom.svg')"
          ></v-img>
          <span
            style="text-transform: capitalize"
            :class="
              switch_language == 'en' ? 'text_title_underline_7' : 'text_body_7'
            "
            v-if="!mobile"
            >English</span
          >
        </v-btn>
      </v-toolbar-items>
      <v-divider
        v-show="current_path == '/search'"
        class="mx-0"
        inset
        vertical
      ></v-divider>
      <v-toolbar-items v-show="current_path == '/search'">
        <v-btn text @click="setShowLanguage('th')">
          <v-img
            class="mr-2"
            width="20"
            :src="require('@/assets/flag/thailand.svg')"
          ></v-img>
          <span
            :class="
              switch_language == 'th' ? 'text_title_underline_7' : 'text_body_7'
            "
            v-if="!mobile"
            >ภาษาไทย</span
          >
        </v-btn>
      </v-toolbar-items>
      <!-- zoom -->
      <span class="text_body_7" v-if="!mobile">
        {{
          switch_language == "th"
            ? text.zoom.th
            : switch_language == "en"
            ? text.zoom.en
            : "-"
        }}
      </span>
      <v-btn
        class="ml-1"
        small
        icon
        @click="resize('minus')"
        :disabled="zoom_minus_disable"
      >
        <v-avatar size="18" color="white">
          <v-icon size="12" color="black">mdi-minus</v-icon>
        </v-avatar>
      </v-btn>
      <span class="text_body_7">{{ solution_size }}%</span>
      <v-btn
        class="ml-1 mr-2"
        icon
        small
        @click="resize('plus')"
        :disabled="zoom_plus_disable"
      >
        <v-avatar size="18" color="white">
          <v-icon size="12" color="black">mdi-plus</v-icon>
        </v-avatar>
      </v-btn>
    </v-app-bar>
    <!-- <pre>{{menus}}</pre> -->
    <router-view id="zoomRouterView" class="mt-7"></router-view>

    <v-footer inset color="#F0F0F0" class="py-2" v-if="!mobile">
      <v-row justify="center" align="center">
        <v-col cols="12" justify="center" align="center">
          <span class="text_title_6">
            {{
              switch_language == "th"
                ? text.footer_office.th
                : switch_language == "en"
                ? text.footer_office.en
                : "-"
            }}
          </span>
          <span class="text_title_6">
            {{
              switch_language == "th"
                ? text.footer_phone_title.th
                : switch_language == "en"
                ? text.footer_phone_title.en
                : "-"
            }}
          </span>
          <span class="text_body_6">
            {{
              switch_language == "th"
                ? text.footer_phone_detail.th
                : switch_language == "en"
                ? text.footer_phone_detail.en
                : "-"
            }}
          </span>
        </v-col>
        <v-col class="py-0" cols="12" justify="center" align="center">
          <span class="text_title_6">
            {{
              switch_language == "th"
                ? text.footer_email_title.th
                : switch_language == "en"
                ? text.footer_email_title.en
                : "-"
            }}
          </span>
          <span class="text_body_6">
            {{
              switch_language == "th"
                ? text.footer_email_detail.th
                : switch_language == "en"
                ? text.footer_email_detail.en
                : "-"
            }}
          </span>
        </v-col>
      </v-row>
    </v-footer>
    <v-footer inset color="#F0F0F0" class="py-2" v-else-if="mobile">
      <v-row justify="center" align="center">
        <v-col class="py-0" cols="12" justify="center" align="center">
          <span class="text_title_6">
            {{
              switch_language == "th"
                ? text.footer_office.th
                : switch_language == "en"
                ? text.footer_office.en
                : "-"
            }}
          </span>
        </v-col>
        <v-col class="py-0" cols="12" justify="center" align="center" asd>
          <span class="text_title_6">
            {{
              switch_language == "th"
                ? text.footer_phone_title.th
                : switch_language == "en"
                ? text.footer_phone_title.en
                : "-"
            }}
          </span>
          <span class="text_body_6">
            {{
              switch_language == "th"
                ? text.footer_phone_detail.th
                : switch_language == "en"
                ? text.footer_phone_detail.en
                : "-"
            }}
          </span>
        </v-col>
        <v-col class="py-0" cols="12" justify="center" align="center">
          <span class="text_title_6">
            {{
              switch_language == "th"
                ? text.footer_email_title.th
                : switch_language == "en"
                ? text.footer_email_title.en
                : "-"
            }}
          </span>
          <span class="text_body_6">
            {{
              switch_language == "th"
                ? text.footer_email_detail.th
                : switch_language == "en"
                ? text.footer_email_detail.en
                : "-"
            }}
          </span>
        </v-col>
      </v-row>
    </v-footer>

    <v-dialog
      v-model="zoom_size_dialog"
      persistent
      :hide-overlay="true"
      max-width="250px"
      transition="dialog-transition"
      style="border-radius: 30px"
      v-if="mobile"
    >
      <v-card height="250px" style="opacity: 0.7; border-r">
        <v-container grid-list-xs class="fill-height">
          <v-row justify="center" align="center">
            <v-col cols="10" class="py-0" justify="center" align="center">
              <font style="font-size: 72px; font-weight: bold"
                >{{ solution_size }}%</font
              >
            </v-col>
            <v-col cols="10" class="py-0" justify="center" align="center">
              <div class="text-center text_title_4">
                {{
                  switch_language == "th"
                    ? text.zoom_in_out.th
                    : switch_language == "en"
                    ? text.zoom_in_out.en
                    : "-"
                }}
              </div>
            </v-col>
          </v-row>
        </v-container>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="language_dialog"
      persistent
      :hide-overlay="true"
      max-width="250px"
      transition="dialog-transition"
      style="border-radius: 30px"
      v-if="mobile"
    >
      <v-card height="250px" style="opacity: 0.7; border-r">
        <v-container grid-list-xs class="fill-height">
          <v-row justify="center" align="center">
            <v-col cols="10" class="py-0" justify="center" align="center">
              <font style="font-size: 72px; font-weight: bold">
                {{
                  switch_language == "th"
                    ? text.language_th_en.th
                    : switch_language == "en"
                    ? text.language_th_en.en
                    : "-"
                }}
              </font>
            </v-col>
          </v-row>
        </v-container>
      </v-card>
    </v-dialog>
  </v-app>
</template>

<script>
import { text_app } from "@/assets/javascript/dataLanguage.js";
import { bus } from "@/main";
import NotificationMenu from "./RequestWord/NotificationMenu";
export default {
  components: { NotificationMenu },
  data() {
    return {
      header_token: {
        headers: {
          token: this.$session.get("token_roy"),
        },
      },
      // permission variable
      permission_request_word: this.$session.get("permission_backOffice")
        ? this.$session
            .get("permission_backOffice")
            .includes("request_word_and_notification")
        : false,
      // mobile
      navbar_drawer: null,
      // =======
      solution_size: 100,
      switch_language: "th",
      text: null,
      fullName: "",
      // Zoom variable
      zoom_minus_disable: false,
      zoom_plus_disable: false,
      zoom_size_dialog: false,
      zoom_size_dialog_const_time: 1000,
      zoom_size_dialog_set_timeout: null,
      // Language variable
      language_dialog: false,
      language_dialog_const_time: 1000,
      language_dialog_set_timeout: null,
      menus: [
        {
          title: "หน้าหลัก",
          path: "/search",
          img: require("@/assets/navbarImage/Home.png"),
          permission: true,
          sub_menus: [],
        },
        {
          title: "แดชบอร์ด",
          path: "/",
          img: require("@/assets/navbarImage/Dashboard.png"),
          permission: this.$session.get("permission_backOffice")
            ? this.$session.get("permission_backOffice").length > 0
            : false,
          sub_menus: [
            {
              title: "สร้างคำทับศัพท์",
              path: { name: "Create Word", params: { mode: "create" } },
              img: require("@/assets/navbarImage/Dictionary.png"),
              permission: this.$session.get("permission_backOffice")
                ? this.$session
                    .get("permission_backOffice")
                    .includes("create_edit_word")
                : false,
            },
            {
              title: "คำทับศัพท์ในฐานข้อมูลทั้งหมด",
              path: { name: "Dashboard", params: { mode: "all" } },
              img: require("@/assets/navbarImage/AllWord.png"),
              permission: this.$session.get("permission_backOffice")
                ? this.$session
                    .get("permission_backOffice")
                    .includes("dashboard")
                : false,
            },
            {
              title: "คำทับศัพท์ที่เผยแพร่แล้ว",
              path: { name: "Dashboard", params: { mode: "created" } },
              img: require("@/assets/navbarImage/CreateWord.png"),
              permission: this.$session.get("permission_backOffice")
                ? this.$session
                    .get("permission_backOffice")
                    .includes("dashboard")
                : false,
            },
            {
              title: "คำทับศัพท์ที่รอการเผยแพร่",
              path: { name: "Dashboard", params: { mode: "edited" } },
              img: require("@/assets/navbarImage/EditWord.png"),
              permission: this.$session.get("permission_backOffice")
                ? this.$session
                    .get("permission_backOffice")
                    .includes("dashboard")
                : false,
            },
          ],
        },
        {
          title: "แบบประเมินความพึงพอใจ",
          path: "/satisfaction",
          img: require("@/assets/navbarImage/Stisfaction.png"),
          permission: this.$session.get("permission_backOffice")
            ? this.$session
                .get("permission_backOffice")
                .includes("satisfaction")
            : false,
          sub_menus: [],
        },
        {
          title: "ประวัติการค้นหาคำศัพท์",
          path: "/",
          img: require("@/assets/navbarImage/SearchHistoty.png"),
          permission: this.$session.get("permission_backOffice")
            ? this.$session.get("permission_backOffice").includes("history") ||
              this.$session
                .get("permission_backOffice")
                .includes("unknown_word")
            : false,
          sub_menus: [
            {
              title: "คำศัพท์ที่ค้นหามากที่สุด",
              path: { name: "History", params: { mode: "history" } },
              img: require("@/assets/navbarImage/20Top.png"),
              permission: this.$session.get("permission_backOffice")
                ? this.$session.get("permission_backOffice").includes("history")
                : false,
            },

            {
              title: "คำศัพท์ที่ไม่มีในระบบ",
              path: { name: "History", params: { mode: "unknown_word" } },
              img: require("@/assets/navbarImage/20NotFound.png"),
              permission: this.$session.get("permission_backOffice")
                ? this.$session
                    .get("permission_backOffice")
                    .includes("unknown_word")
                : false,
            },
          ],
        },

        {
          title: "ตั้งค่าระบบ",
          path: "/setting",
          icon: "settings",
          img: require("@/assets/navbarImage/Setting.png"),
          permission: this.$session.get("permission_setting")
            ? this.$session.get("permission_setting").length > 0
              ? true
              : false
            : false,
          sub_menus: [
            {
              title: "ภาษา",
              path: "/setting/language",
              img: require("@/assets/navbarImage/Lanuage.png"),
              permission: this.$session.get("permission_setting")
                ? this.$session.get("permission_setting").includes("language")
                : false,
            },
            {
              title: "หมวดหมู่",
              path: "/setting/category",
              img: require("@/assets/navbarImage/Category.png"),
              permission: this.$session.get("permission_setting")
                ? this.$session.get("permission_setting").includes("category")
                : false,
            },
            {
              title: "สิทธิ์การใช้งาน",
              path: "/setting/permission",
              img: require("@/assets/navbarImage/License.png"),
              permission: this.$session.get("permission_setting")
                ? this.$session.get("permission_setting").includes("permission")
                : false,
            },
          ],
        },
        {
          title: "ออกจากระบบ",
          path: "logout",
          icon: "mdi-logout",
          img: require("@/assets/navbarImage/Logout.png"),
          permission: this.$session.get("permission_backOffice")
            ? this.$session.get("permission_backOffice").includes("dashboard")
            : false,
          sub_menus: [],
        },
      ],
    };
  },

  computed: {
    show_menu() {
      if (this.$session.get("token_roy")) {
        return true;
      } else {
        return false;
      }
    },
    mobile() {
      if (
        this.$vuetify.breakpoint.width >= 320 &&
        this.$vuetify.breakpoint.width < 768
      ) {
        return true;
      } else {
        return false;
      }
    },
    tablet() {
      if (
        this.$vuetify.breakpoint.width >= 768 &&
        this.$vuetify.breakpoint.width < 1440
      ) {
        return true;
      } else {
        return false;
      }
    },
    desktop() {
      if (this.$vuetify.breakpoint.width >= 1440) {
        return true;
      } else {
        return false;
      }
    },
    current_path() {
      this.setDefaultSolution();
      return this.$route.fullPath;
    },
    roleName() {
      return this.$session.get("permission_permissionName");
    },
  },

  watch: {
    switch_language(value) {
      if (value == "th") {
        bus.$emit("switchLanguage", "th");
      } else if (value == "en") {
        bus.$emit("switchLanguage", "en");
      }
    },
    solution_size(value) {
      if (value) {
        if (this.zoom_size_dialog == false) {
          this.zoom_size_dialog = true;
        }
        clearTimeout(this.zoom_size_dialog_set_timeout);
        this.zoom_size_dialog_set_timeout = setTimeout(() => {
          this.zoom_size_dialog = false;
        }, this.zoom_size_dialog_const_time);
      } else {
        clearTimeout(this.zoom_size_dialog_set_timeout);
        this.zoom_size_dialog = false;
      }
    },
  },
  created() {
    // console.log(this.$session.getAll());
    this.fullName = this.$session.get("fullname");
    this.text = text_app;
    // this.permission_request_word = this.$session.get("permission_backOffice")
    //   ? this.$session
    //       .get("permission_backOffice")
    //       .includes("request_word_and_notification")
    //   : false;
  },
  mounted() {
    this.setDefaultSolution();
  },
  methods: {
    setDefaultSolution() {
      this.solution_size = 100;
      this.zoom_minus_disable = false;
      this.zoom_plus_disable = false;
      // zoomRouterView.style.zoom = "100%";
    },
    resize(action) {
      if (action == "plus") {
        if (this.solution_size < 150) {
          this.solution_size += 10;
          zoomRouterView.style.zoom = this.solution_size + "%";
          this.zoom_minus_disable = false;
          if (this.solution_size == 150) {
            this.zoom_plus_disable = true;
          }
        }
      } else if (action == "minus") {
        if (this.solution_size > 50) {
          this.solution_size -= 10;
          zoomRouterView.style.zoom = this.solution_size + "%";
          this.zoom_plus_disable = false;
          if (this.solution_size == 50) {
            this.zoom_minus_disable = true;
          }
        }
      }
    },
    setShowLanguage(language) {
      if (language) {
        this.switch_language = language;
        if (this.language_dialog == false) {
          this.language_dialog = true;
        }
        clearTimeout(this.language_dialog_set_timeout);
        this.language_dialog_set_timeout = setTimeout(() => {
          this.language_dialog = false;
        }, this.language_dialog_const_time);
      } else {
        clearTimeout(this.language_dialog_set_timeout);
        this.language_dialog = false;
        this.switch_language = "";
      }
    },
    logout() {
      let data = {
        userId: this.$session.get("user_id_roy"),
      };
      this.axios
        .post(
          process.env.VUE_APP_API + "api/v1/logout/",
          data,
          this.header_token
        )
        .then((response) => {
          // console.log(response.data);
          if (response.data == "success") {
            this.$session.clear();
            this.$router.push("/login");
            this.$swal.fire({
              icon: "success",
              title: "ออกจากระบบสำเร็จ !",
              showConfirmButton: false,
              timer: 1000,
            });
          }
        })
        .catch((err) => {
          // console.log("api logout err!!");
        });
    },
  },
};
</script>
